<template>
  <v-autocomplete v-model="store.conceptId" label="Rechercher un concept" :search-input.sync="conceptLabel"
    @input="searchProcess" :items="autocompleteConcept" item-text="prefLabel" item-value="id" hide-no-data hide-details
    no-filter outlined dense autocomplete="off">
    <template v-slot:item="{ item }">
      <div :class="{ 'font-italic': item.individual || false }">
        {{ item.prefLabel }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import ConceptsStore from "../concepts-store";
import axios from "axios";
import Utils from "../utils";
import Snomed from "../snomed";
export default {
  name: "ConceptsSearch",

  data() {
    return {
      store: ConceptsStore.state,
      conceptLabel: '',
      autocompleteConcept: [],
      searchLang: ''
    }
  },

  async beforeCreate() {
    await this.$router;
    this.searchLang = this.$route.query.lang;
  },

  watch: {
    // Reset the search language when user switch lang.
    $route(to, from) {
      if (to.query?.lang !== from.query?.lang) {
        this.searchLang = to.query?.lang;
      }
    },

    conceptLabel() {
      if (this.conceptLabel !== null && this.conceptLabel !== '') {
        this.autocompleteProcessDebounced();
      }
    },
  },

  methods: {
    /**
     * Update URL with the concept URI of the selected concept then reload page.
     */
    searchProcess: function () {

      if (this.store.conceptId !== this.$route.query.concept) {
        ConceptsStore.updateUrlParameters({ concept: this.store.conceptId }, true);
      }
    },

    /**
     * Define a delay before sending autocomplete request to the server.
     */
    autocompleteProcessDebounced: function () {

      clearTimeout(this._searchTimerId);

      this._searchTimerId = setTimeout(() => {
        this.autocompleteProcess();
      }, 300);
    },

    /**
     * Call autocompletion API in order to retrieve suggestions depending on the user's request.
     *
     * @returns {Promise<void>}
     */
    autocompleteProcess: async function () {
      if (this.conceptLabel.length <= 2) {
        this.autocompleteConcept = [];
        return;
      }

      await ConceptsStore.refreshUserTokenIfExpired();

      let endpoint = '/api/concepts/search';
      let params = {
        'searchedText': this.conceptLabel,
        'pagination': this.store.page,
        'size': 20, // Restrict the autocomplete to 20 items
        'terminologyFilters': this.store.terminologyId,
        'lang': this.searchLang,
        'isBrowserSnomedLicence': Snomed.checkIfSnomedBrowerLicenceValid()
      };


      // genérer terminologySpecifiqueFacetInputList à partir des facettes sélectionnées
      const queryString = Utils.buildCustomParamsForAxios(params);
      const requestBody = {
        facets: [], // Déprécié, mais nécessaire pour l'API
        terminologySpecifiqueFacets: []
      };

      await axios.post(
        this.$searchResultManager.middlewareBaseUrl + endpoint + '?' + queryString,
        requestBody,
        { headers: ConceptsStore.buildAuthorizationHeader() }
      ).then((response) => { // Handle success
        this.autocompleteConcept = response.data.concepts;
      }).catch((error) => {
        if (JSON.stringify(error.response?.data).includes("Unknown language:")) {
          this.searchLang = "";
          this.autocompleteProcess(this.conceptLabel);
        }
        console.error("Error while calling autocomplete API: ", error);
      });
    },
  }
}
</script>
